import {Component, Input, OnInit, OnDestroy} from '@angular/core';
import {ErrorService} from '@app/services';
import {UserSearchParams} from '../user-search-params';
import {UserService} from '../user.service';
@Component({
  selector: 'hpf-user-count',
  templateUrl: './user-count.component.html'
})
export class UserCountComponent implements OnInit {
  /** The filters */
  @Input() searchParams: UserSearchParams = new UserSearchParams();
  /** Count result */
  count: number;
  /** Load flag */
  loaded = false;
  /** Constructor */
  constructor(private userService: UserService,
              private errorService: ErrorService) {}
  /** Init */
  ngOnInit() {
    this.userService.count(this.searchParams.toObject())
    .then((count) => {
      this.count = count;
      this.loaded = true;
    })
    .catch((error) => this.errorService.handle(error))
  }
}
